import { toCamelCaseObj } from '@utils';
import {
  RecommendationsEndpoints,
  intradayPrivateFetcher,
} from '../services/fetchers';
import { APIResponse } from '../types/api';
import {
  PreRecommendationDetails,
  RecommendationDetails,
} from '../types/recommendations';

export async function getPreRecommendationDetails(live = false) {
  try {
    const response = await intradayPrivateFetcher.get<
      APIResponse<PreRecommendationDetails>
    >(RecommendationsEndpoints.preRecommendationDetails, { params: { live } });

    return toCamelCaseObj(response?.data?.data);
  } catch (e: any) {
    throw e?.response?.data;
  }
}

export type GetRecommendationsParams = {
  basketType: string;
  live: boolean;
};
export async function getRecommendations({
  basketType,
  live,
}: GetRecommendationsParams) {
  try {
    const response = await intradayPrivateFetcher.get<
      APIResponse<RecommendationDetails>
    >(RecommendationsEndpoints.recommendations(basketType), {
      params: { live },
    });
    return response?.data?.data;
  } catch (e: any) {
    throw e?.response?.data;
  }
}
